<template>
  <div>
    <SellHeader :img_header="header_image" header="คำสั่งซื้อ" link_back="sell/orderretailcustomers"/>
    <Pay_incorrect/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/clipboard_2.png";
import Pay_incorrect from "@/components/admin/sell/Pay_incorrect";
export default {
  name: "PayIncorrect",
  components: {
    Pay_incorrect,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
